

























































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import numeral from 'numeral';
import quotationServices from '@/services/quotation-services';

@Component
export default class LinkedOrders extends Vue {
    @Prop({ required: true })
    private quotationId!: number | string;

    @Prop({ default: () => [] })
    private initialOrders!: any[];

    private orders: any[] = [];
    private isLoading: boolean = false;

    @Watch('initialOrders', { immediate: true })
    private onInitialOrdersChange(val: any[]) {
        if (Array.isArray(val) && val.length > 0) {
            this.orders = val;
        } else {
            this.fetchData();
        }
    }

    private async fetchData() {
        if (!this.quotationId) return;
        this.isLoading = true;
        try {
            const res: any = await quotationServices.getLinkedOrders(this.quotationId);
            if (res && res.data && res.data.status === 200) {
                this.orders = Array.isArray(res.data.data) ? res.data.data : [];
            }
        } catch (e) {
            console.error('Không thể tải đơn MD liên kết:', e);
        } finally {
            this.isLoading = false;
        }
    }

    private openOrderDetail(orderId: number | string) {
        if (!orderId) return;
        const routeData = this.$router.resolve({
            name: 'order-detail',
            params: { orderId: orderId.toString() }
        });
        window.open(routeData.href, '_blank');
    }

    private get totalAmountVND(): number {
        return this.orders.reduce((sum, o) => sum + (Number(o.amount_vnd) || 0), 0);
    }

    private get totalFeeShipCN(): number {
        return this.orders.reduce((sum, o) => sum + (Number(o.fee_ship_cn) || 0), 0);
    }

    private get totalFeeBuy(): number {
        return this.orders.reduce((sum, o) => sum + (Number(o.fee_buy_amount) || 0), 0);
    }

    private get totalMinDeposit(): number {
        return this.orders.reduce((sum, o) => sum + (Number(o.min_deposit) || 0), 0);
    }

    private formatCurrency(val: number): string {
        if (!val) return '0 đ';
        return numeral(val).format('0,0') + ' đ';
    }

    private formatDate(d: string): string {
        if (!d) return '—';
        return d.replace('T', ' ').substring(0, 19);
    }

    private getStatusText(st: number): string {
        const map: Record<number, string> = {
            1: 'Chờ duyệt',
            2: 'Đã duyệt',
            3: 'Chờ đặt cọc',
            4: 'Đã đặt cọc',
            5: 'Đang mua hàng',
            6: 'Đã mua hàng',
            7: 'Người bán phát hàng',
            8: 'Đã nhập kho TQ',
            9: 'Đang vận chuyển',
            10: 'Đã nhập kho VN',
            11: 'Yêu cầu giao hàng',
            12: 'Đã giao hàng',
            13: 'Đã hoàn thành',
            14: 'Đã hủy',
        };
        return map[st] || `Trạng thái ${st}`;
    }

    private getStatusBadgeClass(st: number): string {
        if ([12, 13].includes(st)) return 'label-success';
        if ([14].includes(st)) return 'label-danger';
        if ([4, 5, 6].includes(st)) return 'label-primary';
        if ([8, 9, 10].includes(st)) return 'label-info';
        return 'label-warning';
    }
}
